import { inject, makeStateKey, TransferState } from "@angular/core";
import { ResolveFn} from "@angular/router";
import {IClubWithActiveCourseModel} from "@app/pages/clubs/models/club-with-active-course-model";
import { of} from "rxjs";
import {LocalRepository} from "@shared/helper/local-repository";

import {ClubAggregatorService} from "@app/pages/clubs/services/club-aggregator.service";
import {TServiceResult} from "@shared/helper/t-service-result";
import {PageList} from "@shared/model/categoryAndSearch/pageList-model";
import {TermFilterModel} from "@shared/model/categoryAndSearch/term-filter-model";
import {switchMap} from "rxjs/operators";

export const STATE_KEY_CLUBS = makeStateKey<ClubsResolverData>('STATE_KEY_CLUBS');


export const ClubsResolver: ResolveFn<ClubsResolverData> = (route, state) => {
  const clubsTermFilter = new TermFilterModel();

  const _localRepository: LocalRepository = inject(LocalRepository);
  const serverState: TransferState = inject(TransferState);
  const clubAggregatorService: ClubAggregatorService = inject(ClubAggregatorService);
  if (!_localRepository.IsInBrowser) {
    return clubAggregatorService.getGuestClubs(route.paramMap.get('id')!, clubsTermFilter)
      .pipe(switchMap(res => {
        serverState.set(STATE_KEY_CLUBS, res);
        return of(res);
      }));
  }

  return of(serverState.get(STATE_KEY_CLUBS, TServiceResult.fromFailure<any>(null)))
}


export type ClubsResolverData = TServiceResult<PageList<IClubWithActiveCourseModel>>;
